import * as React from 'react';
import { useId } from 'react';
import * as styles from './BrandMark.css';

export interface BrandMarkProps extends React.SVGAttributes<SVGSVGElement> {
  /** Rendered width/height in px (square). Default 32. */
  size?: number;
  ref?: React.Ref<SVGSVGElement>;
}

/**
 * BrandMark — the Genesis brand glyph: a dark navy gradient "rail tile" with a
 * white "A" of two converging agent-streams joined by a teal coordination
 * crossbar. The canonical mark (also the Auth0 Universal Login logo +
 * Storybook favicon, see infra/auth0/branding + .storybook/static). Decorative
 * by default via role="img" + a fixed accessible name.
 */
export function BrandMark({ size = 32, ref, ...props }: BrandMarkProps) {
  const gid = useId();
  return (
    <svg
      ref={ref}
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="Agentis Genesis"
      {...props}
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" className={styles.tileStart} />
          <stop offset="1" className={styles.tileEnd} />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill={`url(#${gid})`} />
      <g fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 25 L16 8 L24 25" className={styles.leg} strokeWidth="3.4" />
        <path d="M10.8 19 L21.2 19" className={styles.bar} strokeWidth="3" />
      </g>
    </svg>
  );
}
BrandMark.displayName = 'BrandMark';
